import { StyleSheet } from 'react-native';
import { errorRed } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginTop: 10,
    marginBottom: 10,
  },
  text: {
    color: errorRed,
    textAlign: 'center',
    fontWeight: 'bold',
  },
});
